<template>
  <div>
    <v-layout
      v-if="
        (usuarioLoggedTipe == 'PROVEEDOR' ||
          usuarioLoggedTipe == 'ADMINISTRADOR') &&
        getCodigoPerfil() != 'LEC' && !isContratoCerrado()
      "
    >
      <v-flex xs4>
        <v-btn color="primary" @click="descargaSolicitud()"
          >Descarga Plantilla Edición</v-btn
        >
      </v-flex>
      <v-flex xs4 grid-list-xl>
        <v-toolbar-title class="indigo--text"
          >Carga masiva Edición</v-toolbar-title
        >
        <data-adjunto
          :documentoId="id"
          :tipeView="tipeView"
          :tipeArchive="tipeArchive"
        ></data-adjunto>
      </v-flex>
      <v-flex xs3>
        <v-btn
          color="primary"
          :loading="loading1"
          dark
          class="mb-2"
          @click="procesarCarga()"
        >
          Cargar
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout justify-center>
      <v-flex lg12>
        <div v-if="loading">
          <loading></loading>
        </div>
        <v-layout class="d-flex pa-2">
          <div class="d-flex pa-2" xs12 sm6>
            <v-text-field
              width="300px"
              v-model="txtBusqueda"
              placeholder="Ingresa el nombre o código para la busqueda por palabra clave"
              single-line
            ></v-text-field>
            <v-btn
              color="primary"
              @click="loadData()"
              :disabled="txtBusqueda.length < 3"
              class="shrink"
              ><v-icon dark left>search</v-icon>Buscar</v-btn
            >
            <v-btn
              color="secondary"
              @click="limpiaBuscador()"
              :disabled="txtBusqueda.length < 3"
              class="shrink"
              ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
            >
          </div>
        </v-layout>

        <v-data-table
          :headers="headers"
          :items="itemsSolicitudes"
          hide-actions
          :pagination.sync="miPaginacion"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.establecimiento }}</td>
            <td class="text-xs-left">{{ props.item.salCursos.nivel }}</td>
            <td class="text-xs-left">{{ props.item.salCursos.letra }}</td>
            <td class="text-xs-left">
              {{ props.item.candidato.rolCapId.descripcion }}
            </td>
            <td class="text-xs-left">
              {{ props.item.candidato.rut + "-" + props.item.candidato.dv }}
            </td>
            <td class="text-xs-left">
              {{ props.item.estado_solicitud_cambio }}
            </td>
            <td>
              <v-btn
                v-if="
                  usuarioLoggedTipe == 'AGENCIA' &&
                  props.item.estado_solicitud_cambio == 'ASIGNADO' &&
                  getCodigoPerfil() != 'LEC' && !isContratoCerrado()
                "
                depressed
                outline
                icon
                fab
                dark
                color="green darken-4"
                small
                title="Solicitar cambio"
                @click="
                  solicitarCambio(
                    props.item.id,
                    props.item.salCursos.codigoCurso,
                    props.item.salCursos.nivel,
                    props.item.establecimiento,
                    props.item.salCursos.letra,
                    props.item.candidato.rut,
                    props.item.candidato.dv,
                    props.item.candidato.nombre,
                    props.item.candidato.apellido
                  )
                "
              >
                <v-icon>open_in_new</v-icon>
              </v-btn>
              <v-btn
                v-if="
                  (usuarioLoggedTipe == 'PROVEEDOR' ||
                    usuarioLoggedTipe == 'ADMINISTRADOR') &&
                  getCodigoPerfil() != 'LEC' && !isContratoCerrado()
                "
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
                title="Gestionar Cambio"
                @click="
                  gestionarCambio(
                    props.item.id,
                    props.item.salCursos.codigoCurso,
                    props.item.salCursos.nivel,
                    props.item.establecimiento,
                    props.item.salCursos.letra,
                    props.item.candidato.rut,
                    props.item.candidato.dv,
                    props.item.candidato.nombre,
                    props.item.candidato.apellido,
                    props.item.observaciones,
                    props.item.rol
                  )
                "
              >
                <v-icon>open_in_new</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <template
            v-if="
              usuarioLoggedTipe == 'AGENCIA' &&
              getCodigoPerfil() != 'LEC' && !isContratoCerrado()
            "
          >
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>open_in_new</v-icon> </v-btn
            >Solicitar Cambio
          </template>
          <template
            v-if="
              usuarioLoggedTipe == 'PROVEEDOR' ||
              (usuarioLoggedTipe == 'ADMINISTRADOR' &&
                getCodigoPerfil() != 'LEC' && !isContratoCerrado())
            "
          >
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="primary"
              small
            >
              <v-icon>open_in_new</v-icon> </v-btn
            >Gestionar Cambio
          </template>
        </v-card-actions>
        <!-- PAGINACION -->
        <v-flex xs12 sm6>
          <v-text-field
            value=""
            label="Total de Registros"
            v-model="itemsSolicitudes.length"
            disabled
          ></v-text-field>
        </v-flex>
        <div class="pt-2">
          <v-pagination
            v-model="miPaginacion.page"
            :length="numPaginas"
            :total-visible="7"
            circle
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogLoading" persistent max-width="390">
      <loading-descarga></loading-descarga>
    </v-dialog>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn
        v-if="botonDescarga == true"
        color="primary"
        @click="descargaMasiva()"
        >Descarga</v-btn
      >
      <v-spacer></v-spacer>
    </v-card-actions>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import DataAdjunto from "@/components/AdjuntoData.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "evaluacion-seleccion-tab",

  components: {
    Loading,
    AlertEmpty,
    LoadingDescarga,
    DataAdjunto,
  },

  props: {},

  data() {
    return {
      txtBusqueda: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      dialogLoading: false,
      loading: false,
      alerta: false,
      botonCargar: true,
      botonDescarga: false,
      text: "En construccion",
      loading1: false,
      proveedor: {},
      itemsSolicitudes: [],
      rowsTable: [20],
      contratoId: "",
      headers: [
        { text: "Institucion", sortable: false, value: "establecimiento" },
        { text: "Nivel", sortable: false, value: "nivel" },
        { text: "Letra", sortable: false, value: "letra" },
        { text: "Cargo", sortable: false, value: "rol" },
        { text: "Rut", sortable: false, value: "rut" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Accion", sortable: false, value: "" },
      ],
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      usuarioLogged: "",
      gridDocumento: 20,
      tipeArchive: "",
      tipeView: "",
      id: "",
      codigoCurso: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },
  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.tipeArchive = ".pdf,.doc,.jpg,.png,.xlsx";
    this.loadData();
  },
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    async loadSolicitudFilter() {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
        origenBusqueda: this.tab,
      };
      return await axios
        .post("/candidatos/aplicacion/seleccion/filters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsSolicitudes = await this.loadSolicitudFilter();
      this.miPaginacion.totalItems = this.itemsSolicitudes.length;

      if (this.itemsSolicitudes.length > 0) {
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    descargaSolicitud() {
      this.dialogLoading = true;
      let that = this;
      axios
        .get("/candidatos/aplicacion/seleccion/download/" + this.idContrato, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "PLANILLA_SOLICITUD_CAMBIO.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    procesarCarga() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
      };
      axios
        .post("/candidatos/aplicacion/seleccion/file", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.reload();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.reload();
          }
        });
    },
    gestionarCambio(
      id,
      codigoCurso,
      nivel,
      establecimiento,
      letra,
      rut,
      dv,
      nombre,
      apellido,
      observaciones,
      rol
    ) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "SolicitudesCambio",
          params: {
            id: id,
            tipeView: "modifica",
            codigoCurso: codigoCurso,
            nivel: nivel,
            establecimiento: establecimiento,
            letra: letra,
            rut: rut,
            dv: dv,
            nombre: nombre,
            apellido: apellido,
            observaciones: observaciones,
            rol: rol,
          },
        });
      }, 1000);
    },
    solicitarCambio(
      id,
      codigoCurso,
      nivel,
      establecimiento,
      letra,
      rut,
      dv,
      nombre,
      apellido
    ) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "SolicitudesCambio",
          params: {
            id: id,
            tipeView: "modifica",
            codigoCurso: codigoCurso,
            nivel: nivel,
            establecimiento: establecimiento,
            letra: letra,
            rut: rut,
            dv: dv,
            nombre: nombre,
            apellido: apellido,
          },
        });
      }, 1000);
    },
    descargaMasiva() {
      this.dialogLoading = true;
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
        origenBusqueda: this.tab,
      };
      axios
        .post("/candidatos/download/seleccion/aplicacion", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_APLICACION_SELECCION.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
    limpiaBuscador() {
      this.txtBusqueda = "";
      this.loadData();
    },
  },
};
</script>